/**
 * @param {HTMLElement} headerEl
 */
export function initHeaderScrollShadow(headerEl){
    window.addEventListener('scroll', () => {
        headerEl.classList.toggle('scroll', document.scrollingElement.scrollTop !== 0);
    });
}